import { PREVIEW_HTML_TEMPLATE_URL } from 'modules/templateEditor/common/constants';

import { TemplateType } from 'constants/templateTypes';
import { TemplateType as TemplateTypeValue } from 'modules/templateEditor/common';

/**
 * Returns the preview URL for the template in a new tab
 * @param templateId
 * @param locale
 */
export const getPreviewHTMLTemplateUrl = (templateId: number, locale?: string) =>
  `${PREVIEW_HTML_TEMPLATE_URL}?templateId=${templateId}${locale ? `&locale=${locale}` : ''}`;

export const getTemplateTypeLabel = (type: TemplateTypeValue) => {
  if (type === TemplateType.BusinessInitiated) {
    return 'Business-initiated';
  } else if (type === TemplateType.UserInitiated) {
    return 'User-initiated';
  }
  return '';
};
